export default __webpack_public_path__ + "static/media/smile-4.46beaa76.svg";